import * as tslib_1 from "tslib";
import { Router, ActivatedRoute } from '@angular/router';
import { AlertController, Platform } from '@ionic/angular';
import { RequestsType } from '../model/appConfig';
import { User } from '../model/user.model';
import { AppService } from '../services/app.service';
import { AuthService } from '../services/auth.service';
import { PlayerService } from '../services/player.service';
import { SignalRService } from '../services/signalr.service';
export class LoginComponent {
    constructor(authService, playerService, router, appService, route, alertController, platform, signalRService) {
        this.authService = authService;
        this.playerService = playerService;
        this.router = router;
        this.appService = appService;
        this.route = route;
        this.alertController = alertController;
        this.platform = platform;
        this.signalRService = signalRService;
        this.name = "";
        this.password = "";
        this.error = "";
        this.children = [];
        this.route.params.subscribe(p => {
            this.name = this.authService.prevUser.name;
            this.password = this.authService.prevUser.password;
        });
    }
    login(isChildUser) {
        this.name = this.name.trim().toLocaleLowerCase();
        this.password = this.password.trim().toLocaleLowerCase();
        const errorMsg = `האפליקצייה לא מצליחה להתחבר לנגן-מחשב, נא לבדוק:
            <ol>
                <li>שהקלדת את היוזר והסיסמה נכון.</li>
                <li>שהמחשב מחובר לאינטרנט - לוודא שכל הכבלים מחוברים כראוי לנגן-מחשב ולכבות ולהדליק אותו, ולחכות דקה לאחר מכן ולבדוק שוב אם התקלה נפתרה.</li>
            </ol>
            במידה והתקלה עדיין לא נפתרה - אנא צרו קשר עם שירות הלקוחות שלנו דרך הווטסאפ בלינק למטה.`;
        if (this.name.length && this.password.length) {
            this.appService.loading = "active";
            this.authService.authenticate(this.name, this.password).subscribe(res => {
                if (res.errorCode === "0") {
                    const permissions = {
                        canControlSchedulerSwitch: this.toOptionalBool(res.canControlSchedulerSwitch),
                        canEditWeeklyScheduler: this.toOptionalBool(res.canEditWeeklyScheduler),
                        canEditSpecialDates: this.toOptionalBool(res.canEditSpecialDates),
                    };
                    this.error = "";
                    this.authService.getChildUsers(this.name, this.password).subscribe(res2 => {
                        this.children = res2.filter(u => u.User !== this.name).map(u => new User(u.User, u.Password, u.NickName, u.Active)).sort();
                        this.authService.saveAuthData(this.name, this.password, this.children, isChildUser, permissions);
                        if (this.children.length > 0) {
                            this.router.navigateByUrl("/auth/cabinet");
                        }
                        if (!res2.find(x => x.User === this.name).Active) {
                            this.appService.loading = "";
                        }
                        else {
                            this.checkSignalRAndAuth();
                        }
                    }, err => {
                        this.appService.loading = "";
                        this.error = `${errorMsg} | getChildUsers`;
                    });
                }
                else {
                    this.appService.loading = "";
                    this.error = errorMsg;
                }
            }, err => {
                this.appService.loading = "";
                this.error = `${errorMsg} | authenticate`;
            });
        }
    }
    toOptionalBool(value) {
        if (value === undefined || value === null) {
            return undefined;
        }
        return !!value;
    }
    checkSignalRAndAuth() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                const config = yield this.appService.getConfig();
                if (config.requestsType === RequestsType.SignalR) {
                    this.signalRService.startConnection(this.authService.currentUser.name)
                        .then(() => {
                        console.log('SignalR Connection started');
                        this.afterAuth();
                    })
                        .catch(err => console.error('Error establishing SignalR connection: ' + err));
                }
                else {
                    this.afterAuth();
                }
            }
            catch (error) {
                console.error('Failed to get config during login:', error);
                // Fallback to HTTP mode
                this.afterAuth();
            }
        });
    }
    afterAuth() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.appService.loadConfig();
            yield this.playerService.start();
            this.appService.loading = "";
            this.router.navigateByUrl("/");
        });
    }
    setCurrentUser(newUser) {
        if (newUser.name !== this.name && newUser.active) {
            this.name = newUser.name;
            this.password = newUser.password;
            this.login(true);
        }
    }
    getUserClass(user) {
        if (this.name === user.name) {
            return "active";
        }
        else if (!user.active) {
            return "disabled";
        }
        else {
            return "";
        }
    }
    logout() {
        this.children = [];
    }
    // Just to check if mobile app was updated. Can delete later
    testPopup() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const alert = yield this.alertController.create({
                header: "Test popup",
                message: "3.10.29" + ` | android: ${this.platform.is("android")}, ios: ${this.platform.is("ios")}, cordova: ${this.platform.is("cordova")}`,
                buttons: ['OK'],
            });
            yield alert.present();
        });
    }
}
